import React from "react";
import { Col, Card } from "react-bootstrap";
import Button from '../../Helpers/Buttons/CovrButton';
import CurrencyFormat from '../../Helpers/Formatters/CurrencyFormat';

function roundToNearestTenThousand(num) {
  num /= 10000;
  num = Math.floor(num / 5) * 5;
  num *= 10000;
  return num;

}

export default function EstimateCard(props) {
  const loadingClass = props.loading ? "loading" : "";
  return (
    <Col sm={6} md={4} className="d-flex">
      <label hidden={true} id={`estimate-${props.id}`}>{props.quote.product} Coverage Amount Estimate</label>
      <Card className={"shadow-sm flex-fill mx-auto " + loadingClass} aria-labelledby={`estimate-${props.id}`}>
        <div className="card-img-top-wrapper" aria-hidden={true} >
          <Card.Img variant="top" src={props.quote.logoUrl} alt="" />
        </div>

        <Card.Body className="d-flex flex-column">
          {!props.loading &&
            <div>
              <div className="d-flex flex-column align-items-center">
                <span className="card-carrier-product">{props.quote.productName}</span>
                <span className="card-carrier-name">{props.quote.carrierName}</span>
                <span className="card-term">{props.quote.termLength} years of coverage</span>
              </div>
              <p className="card-product-description">Lorem ipsum dolor site amet, ipsum labitur lucilius voldemort mel id, ad has</p>
            </div>
          }

          {props.loading &&
            <div>
              <br /><br /><br /><br /><br /><br />
            </div>
          }

          <div className="mt-auto">
            <div className="d-flex flex-column align-items-center mt-auto">
              <span className="card-approx">Approx.</span>
              <span className="card-monthly-rate"><CurrencyFormat number={props.quote.faceAmount ? roundToNearestTenThousand(props.quote.faceAmount) : 0} whole /></span>
              <Button name="Continue" onClick={() => ({})} disabled={props.loading}></Button>
            </div>
          </div>

        </Card.Body>

      </Card>
    </Col>
  )
}



// WEBPACK FOOTER //
// ./src/components/Tools/BudgetBasedQuoter/EstimateCard.js